import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { Checkbox, FormControlLabel } from '@mui/material';

function Persona({ personaUser, personaStatus, setPersonaStatus }) {
  useEffect(() => {}, []);

  const handleCheckChange = () => {
    setPersonaStatus(!personaStatus);
    window.location.reload(false);
  };

  return (
    <FormControlLabel
      control={
        <Checkbox
          data-cy="navbar-Persona-checkbox"
          id="PersonaCheckBox"
          checked={personaStatus}
          onChange={handleCheckChange}
        />
      }
      label={`Impersonate ${personaUser.personaEmail}`}
      labelPlacement="start"
    />
  );
}

Persona.propTypes = {
  personaUser: PropTypes.shape({
    personaEmail: PropTypes.string.isRequired,
  }).isRequired,
  personaStatus: PropTypes.bool.isRequired,
  setPersonaStatus: PropTypes.func.isRequired,
};

export default Persona;
